export const BORDER_RADIUS_DEFAULT = 2;
export const MARGIN_BOTTOM_DEFAULT = 1;
export const CARD_COLOR = "white";
export const PADDING_DEFAULT = "2%";
export const BOX_SHADOW_DEFAULT = 5;
export const SINGLE_COL_MAX_WIDTH_PX = 500;
export const ONE_HUNDRED_PERCENT = "100%";
export const MAX_WIDTH_PX = 1050;
export const SINGLE_COLUMN_WIDTH_PERCENTAGE = 48;
export const getSecondaryButtonStyles = () => ({
    minWidth: "55px",
    padding: "1% 2%",
    marginRight: "2%",
});
